// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + (chunkId === 777 ? "recorder" : chunkId) + "." + {"175":"dbfa713e","599":"879e44f4","777":"18032664"}[chunkId] + ".chunk.js";
};